import FormItemUtil from '../utils/FormItemUtil';
import ArrayUtil from '../utils/ArrayUtil';
import FocusActions from '../actions/FocusActions'
import FormItemConst from '../formItem/FormItemConst';
export default class FocusController
{
	focusableItemsQue = [];
      focusableItemsQue1 = [];
	constructor(itemDesign,formModule)
	{
	  this.formModule = formModule;
	  this.consQue(itemDesign);
	}

      isLocationSkip(baseGroup,target)
      {
            var type = target.type;
            if(type != "DataGrid" && type.indexOf("Editor") == -1)
                  return true;
            if($("#Editor"+target.id).is(":hidden"))
                  return true;

            let _menuItemId = this.formModule.classAlias == "FormModuleLookup"?"FormLookup":window.menuItemId;

            var targetFormItemControl = FormItemUtil.getFormItemControl(
                  FormItemUtil.getFormItemControlKey(_menuItemId,this.formModule.formId,target.id));
            
            if(typeof(targetFormItemControl.isUnderQueryGroup) == "function" 
                  && targetFormItemControl.isUnderQueryGroup())
                  return true;
            
            if(typeof(targetFormItemControl.isSameMainSource) == "function" 
                  && !targetFormItemControl.isSameMainSource(baseGroup))
                  return true;
            
            if(targetFormItemControl.getProperty_ActualSkipTab())
                  return true;
            
            return false;
      }

      setFocusAfterNewRecord(baseGroup)
      {
            if(this.focusableItemsQue == null || this.focusableItemsQue.length == 0)
                  return;
            let isLookup = this.formModule.classAlias == "FormModuleLookup";
            for(let i = 0;i<this.focusableItemsQue.length;i++)
            {
                  let focusableItem = this.focusableItemsQue[i];
                  if(focusableItem.type == "DataGrid")
                  {
                        let _menuItemId = isLookup?"FormLookup":window.menuItemId;
                        let targetFormItemControl = FormItemUtil.getFormItemControl(
                        FormItemUtil.getFormItemControlKey(_menuItemId,this.formModule.props.formId,focusableItem.id));
                        if(targetFormItemControl.group == baseGroup)
                        {
                              //alert("有DataGrid");
                              FocusActions.afterNewRecordDataGridFocusSet(this.formModule.props.formId,focusableItem.id);
                              return;
                        }
                  }
            }
            var target = this.focusableItemsQue[0];
            var tempIndex = 0;
            while(this.isLocationSkip(baseGroup,target))
            {
                  tempIndex ++;
                  if(tempIndex>=this.focusableItemsQue.length)
                  {
                        break;
                  }
                  else if(tempIndex < 0)
                  {
                        tempIndex = this.focusableItemsQue.length - 1;
                  }
                  
                  target = this.focusableItemsQue[tempIndex];
            }
            if(target.type == "DataGrid")
            {
                  FocusActions.afterNewRecordDataGridFocusSet(this.formModule.props.formId,target.id);
            }
            else
            {
                  FocusActions.focusSet(this.formModule.props.formId,target.id,false,false,true);
            }
      }

      isUnderBase(baseControl,targetFormItemControl)
      {
            //null是最顶层
            if(!baseControl || !targetFormItemControl)
                  return true;
            let parentControl = targetFormItemControl;
            while(parentControl && parentControl.classAlias != "FormItemDesignControl")
            {
                  if(parentControl == baseControl)
                        return true;
                  parentControl = parentControl.parentControl;
            }
            return false;
      }

      initFocus(init = true,baseControl = null)
      {
         if(this.focusableItemsQue.length>0)
         {
            var formId = this.formModule.props.formId;
            var menuItemId = this.formModule.props.menuItemId;
            let targetItem = this.focusableItemsQue[0];
            
            var targetFormItemControl = FormItemUtil.getFormItemControl(
                  FormItemUtil.getFormItemControlKey(menuItemId,formId,targetItem.id));
            var tempIndex = 0;
            while(!this.isUnderBase(baseControl,targetFormItemControl) 
                        || this.isFocusSkip({targetFormItemControl:targetFormItemControl,skipPlugin:true})
            )
            {
                  tempIndex ++;
                  //tempIndex = index + i;
                  if(tempIndex>=this.focusableItemsQue.length)
                        return;
                  targetItem = this.focusableItemsQue[tempIndex];
                  targetFormItemControl = FormItemUtil.getFormItemControl(
                        FormItemUtil.getFormItemControlKey(menuItemId,formId,targetItem.id));
            }
            
            FocusActions.focusSet(formId,targetItem.id,false,init);
            //FocusActions.focusSet(formId,"10029",false);
         }
      }

      /*initFocusTabChanged(tabpagexml)
      {
         
      }*/

      isFocusablePlugin(item)
      {
            if(item.Properties.PluginType)
                  return item.Properties.PluginType.Value == FormItemConst.PLUGIN_TYPE_RADIO
                         || item.Properties.PluginType.V == FormItemConst.PLUGIN_TYPE_RADIO
                         || item.Properties.PluginType.Value == FormItemConst.PLUGIN_TYPE_TREE
                         || item.Properties.PluginType.V == FormItemConst.PLUGIN_TYPE_TREE;
            if(item.Properties.ControlType)
                  return item.Properties.ControlType.Value == FormItemConst.PLUGIN_TYPE_RADIO
                         || item.Properties.ControlType.V == FormItemConst.PLUGIN_TYPE_RADIO
                         || item.Properties.ControlType.Value == FormItemConst.PLUGIN_TYPE_TREE
                         || item.Properties.ControlType.V == FormItemConst.PLUGIN_TYPE_TREE;
      }

	consQue(parentItem,pparentItem)
	{
	  for(var i in parentItem.FormItem)
	  {
  	    var item = parentItem.FormItem[i];

          //所有的Editor
          if(item.type.indexOf("Editor")!=-1)
            this.focusableItemsQue1.push(item);
         
  	    if((item.type.indexOf("Editor")!=-1 && parentItem.type != "DataGrid" 
                  && (!pparentItem || (pparentItem&&pparentItem.type!="DataGrid"))) 
                  || (item.type!="ButtonGroup" && item.type.indexOf("Button")!=-1 && parentItem.type!="ButtonMenu") 
                  || item.type == "DataGrid"
                  || (item.type == "Plugin" && this.isFocusablePlugin(item))
            )
            this.focusableItemsQue.push(item);

          this.consQue(item,parentItem);
	  }
	}

      isFocusSkip(args)
      {
            let {targetFormItemControl,skipPlugin} = args;
            let _name = targetFormItemControl.xml.name;
            if($("#"+_name).length>0)
            {
                  if($("#"+_name).is(":hidden"))
                        return true;
            }

            if(targetFormItemControl.isSkipTab())
                  return true;
            if(skipPlugin)
            {
                  if(targetFormItemControl.classAlias == "FormItemPluginControl")
                  {
                        return true;
                        /*let controlType = targetFormItemControl.getProperty_ControlType();
                        if(controlType == FormItemConst.PLUGIN_TYPE_RADIO)
                        {
                              return false;
                        }
                        if(controlType == FormItemConst.PLUGIN_TYPE_TREE)
                        {
                              return false;
                        }*/
                  }
                  
            }
            
            let parentControl = targetFormItemControl.parentControl;
            let tabPageControl = null;
            while(parentControl != undefined && parentControl != null)
            {
               if(parentControl.xml && parentControl.xml.type == "TabPage")
                  tabPageControl = parentControl;
               parentControl = parentControl.parentControl;
            }
            if(tabPageControl != null)
            {
                  var pageId = tabPageControl.xml.name;//"tabpage"+tabPageControl.formId+tabPageControl.xml.id;
                  var $tabpage = $("#"+pageId);
                  if($tabpage.length==0 || $tabpage.css("display") == "none")
                        return true;
            }

            return false;
      }

      changeFocus(item,pre)
      {
            //console.log(FormItemUtil.formItemControls);
      	var menuItemId = this.formModule.props.menuItemId;
      	var formId = this.formModule.props.formId;
            var index = ArrayUtil.indexOf(this.focusableItemsQue,item);
            var i = 1;
            var tempIndex = pre?index-1:index+1;
            if(tempIndex>=this.focusableItemsQue.length)
            {
                  tempIndex = 0;
                  
            }else if(tempIndex < 0)
            {
                  tempIndex = this.focusableItemsQue.length - 1;
            }
            var targetItem = this.focusableItemsQue[tempIndex];
            var baseFormItemControl = FormItemUtil.getFormItemControl(
            	FormItemUtil.getFormItemControlKey(menuItemId,formId,item.id));
            var targetFormItemControl = FormItemUtil.getFormItemControl(
            	FormItemUtil.getFormItemControlKey(menuItemId,formId,targetItem.id));
            while(this.isFocusSkip({targetFormItemControl:targetFormItemControl}))
            {
                  pre?tempIndex --:tempIndex ++;
                  //tempIndex = index + i;
                  if(tempIndex>=this.focusableItemsQue.length)
                  {
                        tempIndex = 0;
                        
                  }else if(tempIndex < 0)
                  {
                        tempIndex = this.focusableItemsQue.length - 1;
                  }
                  
                  targetItem = this.focusableItemsQue[tempIndex];
                  if(targetItem == item)
                  {
                        break;
                  }
                  targetFormItemControl = FormItemUtil.getFormItemControl(
                        FormItemUtil.getFormItemControlKey(menuItemId,formId,targetItem.id));
            }

            targetFormItemControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(menuItemId,formId,targetItem.id));
            var targetGroupAlias = targetFormItemControl.groupAlias;
            
            var formDataSources = this.formModule.formDataSources;
            var currentGroup = formDataSources == null?null:formDataSources.currentGroup;
            var targetGroup = targetFormItemControl.group;
           
            var isChangeGroup = currentGroup != targetGroup;
            
            var newValue;
            
            if(isChangeGroup && currentGroup!=null)
            {
                  //todo group发生切换 记录如果发生更改要先保存
                  currentGroup.doRecordSave(true);
            }
            
            //todo 当只有一个元素的时候 要回填数据
            
            /*if(baseGongqiFormItem is FormItem_Editor && gongqiFormItem==baseGongqiFormItem && baseGongqiFormItem.control != null)
            {
                  GongqiEditor(baseGongqiFormItem.control).setFinalValue();
            }
            formModule.focusController.findControlAndSetFocus("ctrl_"+String(target.@name));    */
            //alert(JSON.stringify(targetFormItemControl.xml))
            //targetFormItemControl.setFocus();
            //alert(JSON.stringify(targetItem));
            //alert(JSON.stringify(targetFormItemControl.xml));
            FocusActions.focusSet(targetFormItemControl.formId,targetItem.id,pre);
      }
}


// WEBPACK FOOTER //
// ./src/components/FocusController.js